import axios from 'axios';
// import store from '@/store'; // 假設 store 在 @/store/index.js

// 1. 建立實例
const api = axios.create({
  baseURL: `${process.env.VUE_APP_BACKEND}/` // 您的 API 基礎 URL
});

// 2. 應用請求攔截器
api.interceptors.request.use(
  async (config) => {
    const store = (await import('@/store')).default;
    const unsafeMethods = ['post', 'put', 'patch', 'delete'];
    const token = store.state.global.accessToken;

    // --- CSRF 邏輯 ---
    if (unsafeMethods.includes(config.method)) {
      config.headers['X-CSRFToken'] = getCookie('csrftoken');
    }

    // --- JWT 邏輯 ---
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    console.error('Request Setup Error:', error.message);
    return Promise.reject(error);
  }
);

// 3. 應用回應攔截器
api.interceptors.response.use(
  (response) => response, // 成功
  async (error) => {
    const originalRequest = error.config;
    console.error('API Error:', error.response?.data || error.message);

    const store = (await import('@/store')).default;

    // 401 刷新邏輯
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      try {
        console.log('Access Token 過期，正在嘗試刷新...');
        const newAccessToken = await store.dispatch('global/refreshToken'); 
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        
        return api(originalRequest); 
        
      } catch (refreshError) {
        console.error('Refresh Token 刷新失敗:', refreshError);
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

// 4. 匯出這個配置好的實例
export default api;

// 輔助函式 (移到最後或保持在頂部皆可)
function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}